// Constants for library components

export const EXERCISE_TYPES = {
  COMPOUND: 'compound',
  ISOLATION: 'isolation',
  CARDIO: 'cardio',
} as const;

export const SYMMETRY_MODES = {
  SYMMETRICAL: 'symmetrical',
  UNILATERAL: 'unilateral',
  BILATERAL: 'bilateral',
} as const;

export const EQUIPMENT_CATEGORIES = {
  CARDIO: 'Cardio',
  STRENGTH: 'Strength',
  FUNCTIONAL: 'Functional',
  ACCESSORIES: 'Accessories',
  TECHNOLOGY: 'Technology',
} as const;

export const EQUIPMENT_STATUS = {
  AVAILABLE: 'Available',
  IN_USE: 'In Use',
  MAINTENANCE: 'Maintenance',
  OUT_OF_ORDER: 'Out of Order',
  RETIRED: 'Retired',
} as const;

export const EQUIPMENT_CONDITION = {
  EXCELLENT: 'Excellent',
  GOOD: 'Good',
  FAIR: 'Fair',
  POOR: 'Poor',
} as const;

export const MAINTENANCE_SCHEDULES = {
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
  QUARTERLY: 'Quarterly',
  ANNUALLY: 'Annually',
} as const;

export const DIFFICULTY_LEVELS = {
  BEGINNER: { min: 1, max: 3, label: 'Beginner' },
  INTERMEDIATE: { min: 4, max: 6, label: 'Intermediate' },
  ADVANCED: { min: 7, max: 8, label: 'Advanced' },
  EXPERT: { min: 9, max: 10, label: 'Expert' },
} as const;

export const RATING_LEVELS = {
  POOR: { min: 1, max: 2, label: 'Poor' },
  FAIR: { min: 3, max: 4, label: 'Fair' },
  GOOD: { min: 5, max: 6, label: 'Good' },
  EXCELLENT: { min: 7, max: 8, label: 'Excellent' },
  OUTSTANDING: { min: 9, max: 10, label: 'Outstanding' },
} as const;

export const DANGER_LEVELS = {
  VERY_LOW: { min: 1, max: 2, label: 'Very Low' },
  LOW: { min: 3, max: 4, label: 'Low' },
  MODERATE: { min: 5, max: 6, label: 'Moderate' },
  HIGH: { min: 7, max: 8, label: 'High' },
  VERY_HIGH: { min: 9, max: 10, label: 'Very High' },
} as const;

export const REP_RANGES = {
  POWER: { min: 1, max: 5, label: 'Power (1-5)' },
  STRENGTH: { min: 6, max: 8, label: 'Strength (6-8)' },
  HYPERTROPHY: { min: 9, max: 15, label: 'Hypertrophy (9-15)' },
  ENDURANCE: { min: 16, max: 25, label: 'Endurance (16-25)' },
  HIGH_ENDURANCE: { min: 26, max: 50, label: 'High Endurance (26+)' },
} as const;

export const UTILIZATION_RANGES = {
  LOW: { min: 0, max: 25, label: 'Low (0-25%)' },
  MODERATE: { min: 26, max: 50, label: 'Moderate (26-50%)' },
  HIGH: { min: 51, max: 75, label: 'High (51-75%)' },
  VERY_HIGH: { min: 76, max: 100, label: 'Very High (76-100%)' },
} as const;

export const COST_RANGES = {
  BUDGET: { min: 0, max: 1000, label: 'Budget ($0-$1,000)' },
  MID_RANGE: { min: 1001, max: 5000, label: 'Mid-range ($1,001-$5,000)' },
  PREMIUM: { min: 5001, max: 15000, label: 'Premium ($5,001-$15,000)' },
  LUXURY: { min: 15001, max: 50000, label: 'Luxury ($15,001+)' },
} as const;

export const AGE_RANGES = {
  NEW: { min: 0, max: 1, label: 'New (0-1 years)' },
  RECENT: { min: 1, max: 3, label: 'Recent (1-3 years)' },
  MATURE: { min: 3, max: 7, label: 'Mature (3-7 years)' },
  OLD: { min: 7, max: 15, label: 'Old (7+ years)' },
} as const;

export const DEFAULT_MUSCLE_GROUPS = [
  'Core', 'Forearms', 'Traps', 'Biceps', 'Glutes'
];

export const MUSCLE_GROUP_CATEGORIES = {
  UPPER_BODY: 'Upper Body',
  LOWER_BODY: 'Lower Body',
  CORE: 'Core',
  FUNCTIONAL: 'Functional',
} as const;

export const ADAPTATION_CATEGORIES = {
  STRENGTH: 'Strength',
  HYPERTROPHY: 'Hypertrophy',
  ENDURANCE: 'Endurance',
  POWER: 'Power',
  FLEXIBILITY: 'Flexibility',
  BALANCE: 'Balance',
  COORDINATION: 'Coordination',
  MOBILITY: 'Mobility',
} as const;

export const TABLE_PAGE_SIZES = [10, 20, 50, 100];

export const SEARCH_DEBOUNCE_MS = 300;

export const AUTO_SAVE_DELAY_MS = 2000; 